import AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import LoginDialog from './LoginDialog';
import { USER_AVAILABLE_CLASSNAME } from './UserStateStore';

export default class LoginManager extends AbstractSubject {
    static #instance: LoginManager | null = null;

    static getInstance(): LoginManager {
        if (this.#instance === null) {
            this.#instance = new LoginManager();
        }

        return this.#instance;
    }

    public static resetInstance(): LoginManager {
        this.#instance = new LoginManager();
        return this.#instance;
    }

    readonly #loginDialog: LoginDialog = LoginDialog.getInstance();

    readonly #loginDialogToggles: HTMLElement[] = [];

    #notifiedIsLoggedIn: boolean = document.body.classList.contains(USER_AVAILABLE_CLASSNAME);

    get isLoggedIn(): boolean {
        return document.body.classList.contains(USER_AVAILABLE_CLASSNAME);
    }

    set isLoggedIn(value: boolean) {
        document.body.classList.toggle(USER_AVAILABLE_CLASSNAME, value);

        if (this.#notifiedIsLoggedIn === value) {
            return;
        }

        this.#notifiedIsLoggedIn = value;
        this.notify();
    }

    private constructor() {
        super();

        if (this.isLoggedIn) {
            return;
        }

        this.#loginDialogToggles = Array.from(
            document.querySelectorAll('[data-role="login-link"]')
        );

        this.#handleLoginDialog();
    }

    #handleLoginDialog(): void {
        this.#loginDialogToggles.forEach((toggle) =>
            toggle.addEventListener('click', async (e: Event): Promise<void> => {
                e.preventDefault();
                await this.#loginDialog.show();
            })
        );
    }
}
